import { throwError as observableThrowError, Observable, Subject, BehaviorSubject, of } from 'rxjs';

import { catchError, map, share, shareReplay } from 'rxjs/operators';
import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';

import { environment } from '@myenv/environment';

import { enMessage } from '@shared/en-us-message';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@layouts/login/authentication.service';
declare var $: any;

@Injectable()
export class SharedService {
  public apiUrl = environment.apiUrl;
  public apiV2Url = environment.apiV2Url;
  public ErrorMsg: Subject<any> = new Subject<any>();
  public SuccessMsg: Subject<any> = new Subject<any>();
  public WarningMsg: Subject<any> = new Subject<any>();
  public InfoMsg: Subject<any> = new Subject<any>();
  public CustomMsg: Subject<any> = new Subject<any>();
  public ServerErrorMsg: Subject<any> = new Subject<any>();
  // public gotPermissions: Subject<any> = new Subject<JSON>();
  private httpClient: HttpClient;
  private emitChangeNotify = new Subject<any>();
  changeEmittedNotify$ = this.emitChangeNotify.asObservable();
  responseMessage: any = {};
  unoHeader = environment.unoHeader;
  returnUrl!: string;
  public activeSeeker: any[] = [];
  resolutionParam = ['.header', 'footer'];
  public customerId!: Number;
  private static readonly DEFAULT_PROFILE_PICTURE = '/assets/img/user.png';
  private profilePictureObjectUrl: string | null = null;
  private profilePictureUserId: string | null = null;
  private profilePictureRequest: Observable<string> | null = null;
  private readonly profilePictureSubject = new BehaviorSubject<string | null>(null);
  readonly profilePicture$ = this.profilePictureSubject.asObservable();

  constructor(

    private http: HttpClient,
    private handler: HttpBackend,
    private router: Router,
    private ngzone: NgZone,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
  ) {
    this.httpClient = new HttpClient(handler);
  }

  private static pendingResponseMessage: any = null;
  private static toastHostCount = 0;

  setResponseMessage(data: any) {
    this.emitChangeNotify.next(data);
  }

  registerToastHost(): () => void {
    SharedService.toastHostCount++;
    return () => {
      SharedService.toastHostCount = Math.max(0, SharedService.toastHostCount - 1);
    };
  }

  get hasToastHost(): boolean {
    return SharedService.toastHostCount > 0;
  }

  setResponseMessageAfterNavigation(data: any) {
    SharedService.pendingResponseMessage = data;
  }

  takeResponseMessageAfterNavigation() {
    const data = SharedService.pendingResponseMessage;
    SharedService.pendingResponseMessage = null;
    return data;
  }

  getCurrentUser(): Observable<any> {
    return JSON.parse(localStorage.getItem('currentUser') || '{}');
  }

  updateUser(data: any): Observable<any> {
    return this.http.put(this.apiUrl + 'users/' + data.userId, data).pipe(
      catchError(this.handleError));
  }

  getVehicleHeader(): Observable<any> {
    return this.http.get(this.apiUrl + 'vehicles/header')
      .pipe(share()).pipe(
        catchError(this.handleError));
  }


  getAllEvVehicles(page: number): Observable<any> {
    return this.http.get(this.apiUrl + 'devices?sortingKey=lastCommunication&direction=desc&key=generation&value=EBIKE&isAssociatedDevice=false&page=0' + page).pipe(
      catchError(this.handleError));
  }

  getDurationBtwTwoEpoch(ts: number, te: number) {
    let delta = Math.abs(te - ts) / 1000;
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;
    const minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;
    const durationInSecs = delta % 60;
    return [days, hours, minutes, durationInSecs];
  }

  // To get all Place
  getAllPlace(): Observable<any> {
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });
    return this.http.get(this.apiUrl + 'places', { headers }).pipe(
      catchError(this.handleError));
  }

  // To get all Alerts
  getAllAlerts(): Observable<any> {
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });
    return this.http.get(this.apiUrl + 'alerts/type', { headers }).pipe(
      catchError(this.handleError));
  }

  getUsers(): Observable<any> {
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });
    return this.http.get(this.apiUrl + 'users', { headers }).pipe(
      catchError(this.handleError));
  }

  getAllCampaign(): Observable<any> {
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });

    return this.http.get(this.apiUrl + 'campaign', { headers }).pipe(
      catchError(this.handleError));
  }

  getAllDevices(): Observable<any> {
    let tempUrl = 'devices?sortingKey=lastCommunication&direction=desc';
    tempUrl += `&attributes=deviceId,serialNumber,assetName,productSerialNumber,vin,lastCommunication,deviceStatus,architectureType,ecuMake,generation,simStatus`;
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });

    return this.http.get(this.apiUrl + tempUrl, { headers }).pipe(
      catchError(this.handleError));
  }

  getAllV2Devices(productType: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    let tempUrl = `${productType}/${this.customerId}/v2/devices?sortingKey=lastCommunication&direction=desc`;
    tempUrl += `&attributes=deviceId,serialNumber,assetName,productSerialNumber,vin,lastCommunication,deviceStatus,architectureType,ecuMake,generation,simStatus`;
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });

    return this.http.get(this.apiV2Url + tempUrl, { headers }).pipe(
      catchError(this.handleError));
  }

  getDashcam(deviceId: string, startTime: number, endTime: number): Observable<any> {
    return this.http.get(this.apiUrl + 'messages/device/' + deviceId + '?messageType=DashCam&page=0&attributes=latitude,longitude,eventTime,heading,vehicleSpeed,messageType,ingestionTimestamp,messageId,camSerialNumber,eventName,videoURL,camType&startTime=' + startTime + '&endTime=' + endTime + '&sort=ASC&limit=10')
      .pipe(catchError(this.handleError));
  }

  getAllV2ActiveDevices(productType: string): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });

    return this.http.get(this.apiV2Url + `${productType}/${this.customerId}/v2/devices?sortingKey=lastCommunication&direction=desc&active=true`, { headers }).pipe(
      catchError(this.handleError));
  }

  getAllActiveDevices(): Observable<any> {
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });

    return this.http.get(this.apiUrl + 'devices?sortingKey=lastCommunication&direction=desc&active=true', { headers }).pipe(
      catchError(this.handleError));
  }

  getAllCustomer(): Observable<any> {
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    });

    return this.http.get(this.apiUrl + 'customers/user', { headers }).pipe(
      catchError(this.handleError));
  }

  getRoles(): Observable<any> {
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });
    return this.http.get(this.apiUrl + 'roles', { headers }).pipe(
      catchError(this.handleError));
  }

  getGroups(): Observable<any> {
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      // 'CUSTOM_X_LCM': 'true'
    });
    return this.http.get(this.apiUrl + 'groups/associated-vehicles', { headers }).pipe(
      catchError(this.handleError));
  }

  getVehiclesView(): Observable<any> {
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
    });
    return this.httpClient.get(this.apiUrl + 'vehicles?sortingKey=lastCommunication&direction=desc', { headers }).pipe(
      catchError(this.handleError));
  }

  searchVehicles(searchValue: string): Observable<any> {
    return this.http.get(this.apiUrl + `messages/latest/search?limit=3000&searchKey=assetName&searchValue=${searchValue}`).pipe(
      catchError(this.handleError));
  }

  getAllVehicles(page: number): Observable<any> {
    return this.http.get(this.apiUrl + 'devices?sortingKey=lastCommunication&direction=desc&page=' + page).pipe(
      catchError(this.handleError));
  }

  getAllfavourites(type: number): Observable<any> {
    return this.http.get(this.apiUrl + `favourite?typeCode=${type}`).pipe(
      catchError(this.handleError));
  }

  getFavDetails(name: string): Observable<any> {
    return this.http.get(this.apiUrl + `favourite/${name}`).pipe(
      catchError(this.handleError));
  }

  deletefavourite(name: string): Observable<any> {
    return this.http.delete(this.apiUrl + 'favourite/' + name).pipe(
      catchError(this.handleError));
  }

  addfavourite(data: any) {
    return this.http.post(this.apiUrl + 'favourite', data).pipe(
      catchError(this.handleError));
  }

  updateFav(name: string, payload: any): Observable<any> {
    return this.http.put(this.apiUrl + `favourite/${name}`, payload).pipe(
      catchError(this.handleError));
  }

  getAllMessages(): Observable<any> {
    return this.http.get(this.apiUrl + 'messages/types').pipe(
      catchError(this.handleError));
  }

  onSearchVehicle(key: string, value: any, data?: any, group?: any, attributes?: any): Observable<any> {
    let tempUrl = `${this.apiUrl}devices?sortingKey=lastCommunication&direction=desc`;
    if (value !== '' && value) {
      tempUrl += `&key=${key}&value=${value}`;
    }
    if (data) {
      tempUrl += `&status=${data}`;
    }
    if (group) {
      tempUrl += `&groups=${group}`;
    }
    if (attributes) {
      tempUrl += `&attributes=${attributes}`;
    }
    return this.http.get(tempUrl).pipe(catchError(this.handleError));
  }

  onSearchDevice(key: string, value: any, page?: number, data?: any, group?: any, active?: boolean, attributes?: any, isAssociatedDevice?: boolean): Observable<any> {
    let tempUrl = `${this.apiUrl}devices?sortingKey=lastCommunication&direction=desc`;
    if (isAssociatedDevice == undefined) {
      isAssociatedDevice = false;
    }
    if (value !== '' && value) {
      tempUrl += `&key=${key}&value=${value}&isAssociatedDevice=${isAssociatedDevice}`;
    }
    if (data) {
      tempUrl += `&status=${data}`;
    }
    if (page || page == 0) {
      tempUrl += `&page=${page}`;
    }
    if (group) {
      tempUrl += `&groups=${group}`;
    }
    if (active) {
      tempUrl += `&active=${active}`;
    }
    if (attributes) {
      tempUrl += `&attributes=${attributes}`;
    }
    return this.http.get(tempUrl).pipe(catchError(this.handleError));
  }

  onSearchV2Device(key: string, value: any, page?: number, productType?: string, data?: any, group?: any, active?: boolean, attributes?: any, isAssociatedDevice?: boolean): Observable<any> {
    this.customerId = JSON.parse(localStorage.getItem('currentUser') || '{}').customerId
    let tempUrl = `${this.apiV2Url}${productType}/${this.customerId}/v2/devices?sortingKey=lastCommunication&direction=desc`;
    if (isAssociatedDevice == undefined) {
      isAssociatedDevice = false;
    }
    if (value !== '' && value) {
      tempUrl += `&key=${key}&value=${value}&isAssociatedDevice=${isAssociatedDevice}`;
    }
    if (data) {
      tempUrl += `&status=${data}`;
    }
    if (page || page == 0) {
      tempUrl += `&page=${page}`;
    }
    if (group) {
      tempUrl += `&groups=${group}`;
    }
    if (active) {
      tempUrl += `&active=${active}`;
    }
    if (attributes) {
      tempUrl += `&attributes=${attributes}`;
    }
    return this.http.get(tempUrl).pipe(catchError(this.handleError));
  }

  onBenchTestDeviceSearch(key: string, value: any): Observable<any> {
    return this.http.get(`${this.apiUrl}devices/bench/search?key=${key}&value=${value}`).pipe(
      catchError(this.handleError));
  }

  getCounts(): Observable<any> {
    return this.http.get(`${this.apiUrl}devices/bench/score`).pipe(
      catchError(this.handleError));
  }


  getDeviceHeader(): Observable<any> {
    return this.http.get(this.apiUrl + 'devices/header')
      .pipe(share()).pipe(
        catchError(this.handleError));
  }

  getVehicleEventDates(deviceId: string, startTime: number, endTime: number): Observable<any> {
    let offset = new Date().getTimezoneOffset() * 60 * 1000 * -1;
    return this.http.get(
      `${this.apiUrl}analytics/device/${deviceId}/messages/newIndicator` +
      `?startTime=${startTime}&endTime=${endTime}&offset=${offset}`
    )
      .pipe(catchError(this.handleError));
  }

  getDeviceEventDates(serialNumber: string, startTime: number, endTime: number): Observable<any> {
    return this.http.get(
      `${this.apiUrl}analytics/serialNumber/${serialNumber}/messages/indicator` +
      `?startTime=${startTime}&endTime=${endTime}`
    )
      .pipe(catchError(this.handleError));
  }

  setOBDHeight(getScreenWidth: number, getScreenHeight: number, isHavingEnoughSpace: boolean, params: any, pidViewTabPos: number) {
    let vh1 = 0;
    const timeSeeker = $('#tskr').height();
    this.resolutionParam.map((e) => {
      const height = $(e).height();
      if (height) { vh1 += height; }
      // if (e === '#tskr' && height) { vh1 += 38; }
    });
    const p = $('#tripView').height(); // trip view
    const q = $('#pidView').height(); // pid section
    const r = $('#messageView').height(); // message view
    vh1 = this.convertPxToVH(vh1);
    vh1 = vh1 + 1;
    const overallHeight = vh1;
    const accordionSection = this.convertPxToVH((p >= 0 ? (p + q) : (q + r)));
    const timeSeekerHeightInVh = this.convertPxToVH(timeSeeker);
    const equation = (100 - (vh1 + timeSeekerHeightInVh));
    // right side container
    const a = (getScreenHeight <= 650) ? (equation * 0.5) : (getScreenHeight > 650 && getScreenHeight <= 800) ? (equation * 0.45) : (getScreenHeight > 800 && getScreenHeight <= 950) ? (equation * 0.40) : (equation * 0.35);
    $('#gmap').height((equation - (a + 1)) + 'vh');
    $('#drawerContent').height((a - 2.5) + 'vh');
    $('#rightSctn').height((equation - 6) + 'vh');

    const leftSctnHeightInVh = 100 - (vh1 + 1);
    $('#leftsctn').height((leftSctnHeightInVh + 'vh'));
    const leftSection = $('#leftsctn').height();
    const firstActiveSection = $('.left-sec')[0].style.display === 'block' ? $($('.left-sec')[0]) : $($('.left-sec')[1]);
    const firstActiveContainer = firstActiveSection.find('#tripsContainer');
    const messageActiveContainer = firstActiveSection.find('#messageContainer');
    const col = $('#leftCol' + params);
    const dataViewSection = $($('.left-sec')[2]); // pids section
    const tripTable = $('#trips');
    const tripInfo = $('#trip_info').height();
    if (!isHavingEnoughSpace) {
      dataViewSection.height(q);
      if (params === 3) { // pid view
        // col.height(100 - (accordionSection + overallHeight + 2.5) + 'vh');
      } else {
        const height = (leftSctnHeightInVh - (this.convertPxToVH(tripInfo) + accordionSection + 2.7));
        // firstActiveSection.css('max-height', 'none');
        // col.css('max-height', (leftSctnHeightInVh - this.convertPxToVH(tripInfo + r)) + 'vh');
        // col.css('max-height', (height - this.convertPxToVH(p + tripInfo)) + 'vh');
        // firstActiveSection.css('max-height', (height + 'vh'));
        firstActiveContainer.css('max-height', height + 'vh');
        messageActiveContainer.css('max-height', height + 'vh');
      }
    } else if (Array.isArray(params)) {
      console.info('Intervend Enough space');
      if (params[0] === 'trip_expand') {
        const table_header = $(firstActiveSection).find('datatable-header').height();
        const height = (leftSctnHeightInVh - (this.convertPxToVH(p)));
        firstActiveSection.css('height', 'auto');
        // firstActiveSection.css('max-height', '50%');
        // console.info(firstActiveSection.height() - (p + tripInfo));
        // $('#leftCol1').css('max-height', (firstActiveSection.height() - (p + tripInfo)));
        // col.css('max-height', (height - this.convertPxToVH(p + tripInfo)) + 'vh');
        // firstActiveSection.css('max-height', (leftSctnHeightInVh - (accordionSection + 2)) + 'vh');
        // $(firstActiveSection).find('datatable-body').css('max-height', firstActiveSection.height() - (p + trip_view + table_header + 12));
      } else if (params[0] === 'trip_collapse') {
        $(firstActiveSection).height(p);
      } else if (params[0] === 'msg_expand') {
        const msg_view = $('#msg_info').height();
        firstActiveSection.css('height', 'auto');
        // firstActiveSection.css('max-height', '50%');
        // $('#leftCol3').height(firstActiveSection.height() - (r + msg_view));
      } else if (params[0] === 'msg_collapse') {
        $($('.left-sec')[1]).height(r);
      }
      if (params[1] === 'data_expand') {
        const height = leftSection - (firstActiveSection.height());
        // $('#drawerContainer').height(height - q);
        dataViewSection.height(height);
      } else if (params[1] === 'data_collapse') {
        dataViewSection.height(q);
      }
    }
    // const col = $('#leftCol' + (view + 1));
    // if (getScreenHeight < slab) {
    // if (view === 1) { // pid view
    //   col.height(100 - (leftCol + overallHeight + 2.5) + 'vh');
    // } else {
    //   col.css('max-height', (100 - (leftCol + overallHeight + (view === 2 ? 0 : 2.5))) + 'vh');
    // }
    // } else {
    //   const dataViewSection = $($('.left-sec')[2]); // pids section
    //   if (view[0] === 'trip_expand') {
    //     const trip_view = $('#trip_info').height();
    //     const table_header = $(firstActiveSection).find('datatable-header').height();
    //     // firstActiveSection.css('max-height', (leftSctnHeightInVh/2) + 'vh');
    //     firstActiveSection.css('height', 'auto');
    //     firstActiveSection.css('max-height', '50%');
    //     $(firstActiveSection).find('datatable-body').css('max-height', firstActiveSection.height() - (p + trip_view + table_header + 12));
    //   } else if (view[0] === 'trip_collapse') {
    //     $(firstActiveSection).height(p);
    //   } else if (view[0] === 'msg_expand') {
    //     const msg_view = $('#msg_info').height();
    //     firstActiveSection.css('height', 'auto');
    //     firstActiveSection.css('max-height', '50%');
    //     $('#leftCol3').height(firstActiveSection.height() - (r + msg_view));
    //   } else if (view[0] === 'msg_collapse') {
    //     $($('.left-sec')[1]).height(r);
    //   }
    //   if (view[1] === 'data_expand') {
    //     const height = leftSection - (firstActiveSection.height());
    //     dataViewSection.height(height);
    //   } else if (view[1] === 'data_collapse') {
    //     dataViewSection.height(q);
    //   }
    // }

    if ((!isHavingEnoughSpace && params === 3) || isHavingEnoughSpace) {
      this.set_OBD_PID_Height(pidViewTabPos);
    }
  }

  set_OBD_PID_Height(pidViewTabPos: number) {
      const pidSection = $('#pidView').height(); // pid section
      const leftSection = $('#leftsctn').height();
      const firstActiveSection = $('.left-sec')[0].style.display === 'block' ? $($('.left-sec')[0]) : $($('.left-sec')[1]);
      const navHeight = $('.nav.nav-tabs.detailed-tabs').height();
      if (pidViewTabPos === 0) {
        const searchBarHeight = $('.input-group.input-group-lg.searchVeh.liveSearch').height();
        const tableHeader = $('#pidTable').find('datatable-header').height();
        const height = leftSection - (firstActiveSection.height() + pidSection + navHeight + searchBarHeight + (tableHeader ? tableHeader : 46) + 10);
        $('#pidTable > div > .datatable-body').css('height', height);
      } else if (pidViewTabPos === 1) {
        const height = leftSection - (firstActiveSection.height() + pidSection + navHeight);
        $('#gps').css('height', height);
      } else {
        const camRow = $('.cambtn').height();
        const height = leftSection - (firstActiveSection.height() + navHeight + camRow);
        $('#cam').height(height);
      }
  }

  convertPxToVH(pixels: number) {
    return pixels * (100 / document.documentElement.clientHeight);
  }

  // getDevicesView(): Observable<any> {
  //
  //   return this.http.get(this.apiUrl + 'devices')
  //     .pipe(share()).pipe(
  //     catchError(this.handleError));
  // }

  getModules(): Observable<any> {
    return this.http.get(this.apiUrl + 'modules')
      .pipe(share()).pipe(
        catchError(this.handleError));
  }

  getRoleAccessModule(roleId: string): Observable<any> {
    return this.http.get(this.apiUrl + 'roles/' + roleId)
      .pipe(share()).pipe(
        catchError(this.handleError));
  }

  getUserRoleId(tokenId: string): Observable<any> {
    return this.http.get(this.apiUrl + 'tokens/' + tokenId)
      .pipe(share()).pipe(
        catchError(this.handleError));
  }

  setAccessRole(accessRoleModules: any, permissionModules: any) {
    localStorage.setItem('accessRoleModules', JSON.stringify(accessRoleModules));
    localStorage.setItem('permissionModules', JSON.stringify(permissionModules));
    // localStorage.setItem('resPermissionModule', JSON.stringify(permissionModules));
  }

  getPermissionModules(): string[] {
    try {
      return JSON.parse(localStorage.getItem('permissionModules') || '[]');
    } catch {
      return [];
    }
  }

  getAccessRoleModules(): { name: string; authorities?: string[] }[] {
    try {
      return JSON.parse(localStorage.getItem('accessRoleModules') || '[]');
    } catch {
      return [];
    }
  }

  isOtaPartnerModule(name: string): boolean {
    return name === 'OTA-PARTNER';
  }

  isOtaPartner(): boolean {
    return this.getPermissionModules().some((m) => this.isOtaPartnerModule(m));
  }

  hasOtaAccess(): boolean {
    const permissionModules = this.getPermissionModules();
    return permissionModules.includes('OTA') ||
      permissionModules.some((m) => this.isOtaPartnerModule(m));
  }

  /** Data Hub (/destinations) is only available to OTA-PARTNER accounts. */
  hasDataHubAccess(): boolean {
    return this.isOtaPartner();
  }

  getEffectiveOtaAuthorities(): string[] {
    const modules = this.getAccessRoleModules();

    if (this.isOtaPartner()) {
      const partner = modules.find((m) => this.isOtaPartnerModule(m.name));
      const ota = modules.find((m) => m.name === 'OTA');
      const authorities = [...(partner?.authorities || []), ...(ota?.authorities || [])]
        .map((a: any) => (typeof a === 'string' ? a : a?.name))
        .filter(Boolean);
      // Ensure create + retry/add-device actions remain available for partner Campaigns/Files
      return Array.from(new Set(['READ', 'WRITE', 'UPDATE', ...authorities]));
    }
    const ota = modules.find((m) => m.name === 'OTA');
    return (ota?.authorities || [])
      .map((a: any) => (typeof a === 'string' ? a : a?.name))
      .filter(Boolean);
  }

  /**
   * Data Hub (destinations) is OTA-PARTNER-only. Fine-grained UI still reads the
   * DESTINATION entry from accessRoleModules; otherwise mirror partner OTA authorities.
   */
  getEffectiveDestinationAuthorities(): { name: string; authorities: string[] } {
    if (!this.hasDataHubAccess()) {
      return { name: 'DESTINATION', authorities: [] };
    }
    const modules = this.getAccessRoleModules();
    const dest = modules.find((m) => m.name === 'DESTINATION');
    if (dest?.authorities?.length) {
      return { name: 'DESTINATION', authorities: [...dest.authorities] };
    }
    const authorities = this.getEffectiveOtaAuthorities();
    return {
      name: 'DESTINATION',
      authorities: authorities.length ? authorities : ['READ', 'WRITE'],
    };
  }

  getReports(): Observable<any> {
    return this.http.get(this.apiUrl + 'reports')
      .pipe(share()).pipe(
        catchError(this.handleError));
  }

  getALReports(): Observable<any> {
    return this.http.get(this.apiUrl + 'reports')
      .pipe(share()).pipe(
        catchError(this.handleError));
  }

  uploadProfilePicture(data: any, userId: string) {
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    /*return this.http.post(this.apiUrl + 'users/' + userId + '/profile/picture', data, { headers })
      .pipe(share()).pipe(
        catchError(this.handleError));*/
    return this.httpClient.post(this.apiUrl + 'users/' + userId + '/profile/picture', data, {headers})
      .pipe(catchError(this.handleError));
  }

  loadProfilePicture(userId: string, refresh = false): Observable<string> {
    if (!userId) {
      this.publishProfilePicture(SharedService.DEFAULT_PROFILE_PICTURE);
      return of(SharedService.DEFAULT_PROFILE_PICTURE);
    }
    if (!refresh && this.profilePictureRequest && this.profilePictureUserId === userId) {
      return this.profilePictureRequest;
    }
    this.profilePictureUserId = userId;
    const cacheBust = refresh ? `&t=${Date.now()}` : '';
    const url = `${this.apiUrl}users/profile/picture?userId=${userId}${cacheBust}`;
    this.profilePictureRequest = this.http.get(url, { responseType: 'blob' }).pipe(
      map((blob) => {
        const objectUrl = URL.createObjectURL(blob);
        this.publishProfilePicture(objectUrl);
        return objectUrl;
      }),
      catchError(() => {
        this.publishProfilePicture(SharedService.DEFAULT_PROFILE_PICTURE);
        return of(SharedService.DEFAULT_PROFILE_PICTURE);
      }),
      shareReplay(1),
    );
    return this.profilePictureRequest;
  }

  private publishProfilePicture(url: string) {
    if (this.profilePictureObjectUrl) {
      URL.revokeObjectURL(this.profilePictureObjectUrl);
      this.profilePictureObjectUrl = null;
    }
    if (url.startsWith('blob:')) {
      this.profilePictureObjectUrl = url;
    }
    this.profilePictureSubject.next(url);
  }

  handleError(error: any | any) {
    return observableThrowError(error.error || error || 'Server error');
  }

  impersonate(data: any) {
    const _headers = new HttpHeaders();
    let token = this.getHeaders();
    const headers = _headers.append('Authorization', 'Bearer ' + token).append('Content-Type', 'application/json');
    return this.http.post(this.apiUrl + 'impersonate/user/' + data + '/login', data).pipe(
      catchError(this.handleError));
  }

  getHeaders() {
    return localStorage.getItem('token') || '';
  }

  getActivity(id: string, page: number, limit: number, filter?: any) {
    let tempUrl = `activity/device/deviceId/${id}?page=${page}&limit=${limit}`;
    if (filter) tempUrl += `&filter=${filter}`;
    return this.http.get(this.apiUrl + tempUrl).pipe(catchError(this.handleError));
  }

  updatePreference(data: any) {
    let token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    });
    return this.httpClient.put(this.apiUrl + 'users/preferences/update', data, { headers }).pipe(
      catchError(this.handleError));
  }

  // To get the vehicle count
  getVehicleCodeCount(deviceId: string, startTime: number, endTime: number) {
    return this.http.get(this.apiUrl + 'analytics/dtc/device/' + deviceId + '/count?startTime=' + startTime + '&endTime=' + endTime);
  }

  getErrorMsg(error: any, type?: string) {
    const errorCodes = [400, 403, 404, 500];
    if (error.headers) {
      error = error.error;
    }
    if (error.status == 401) {
      if (localStorage.getItem('token') || '') {
        let token = localStorage.getItem('token') || '';
        localStorage.clear();
        sessionStorage.clear();
        this.responseMessage = { success: false, message: enMessage.error401 };
        this.setResponseMessage(this.responseMessage);
        this.authenticationService.logout(token).subscribe((res) => {
        });
      }
    }
    if (error.errorCode) {
      const errorCode = error.errorCode;
      const errorMessage = enMessage[errorCode];
      if (!errorMessage) {
        this.responseMessage = { success: false, message: enMessage.internalServerError };
        // this.setResponseMessage(this.responseMessage);
      } else {
        this.responseMessage = { success: false, message: errorMessage, type: type, error: error };
        this.setResponseMessage(this.responseMessage);
      }
    } else if (error.type && error.type === 'error') {
      // this.responseMessage = { success: 'noInternet', message: enMessage.noInternet };
      // this.setResponseMessage(this.responseMessage);
    } else {
      this.responseMessage = { success: false, message: enMessage.internalServerError };
      // this.setResponseMessage(this.responseMessage);
    }
  }

  setDefaultUrl(permissionModules: any) {
    let defaultUrl = '/';
    let returnModule = this.route.snapshot.queryParams['returnModule'];
    const returnModuleAllowed =
      permissionModules.includes(returnModule) ||
      (returnModule === 'OTA' && this.hasOtaAccess()) ||
      (this.isOtaPartnerModule(returnModule) && this.hasOtaAccess());
    if (returnModuleAllowed) {
      if (this.route.snapshot.queryParams['returnUrl'].includes('devices')) {
        defaultUrl = '/devices';
      } else if (this.route.snapshot.queryParams['returnUrl'].includes('campaign-detail')) {
        defaultUrl = '/v2/ota';
      } else {
        defaultUrl = this.route.snapshot.queryParams['returnUrl'];
      }
    } else {
      if (permissionModules.includes('SUPPORT')) {
        defaultUrl = '/support';
        localStorage.setItem('defaultUrl', defaultUrl);
      }
      else {
        if (Array.isArray(permissionModules)) {
          // let defaultUrl;
          // if (permissionModules.includes('USER')) {
          //   defaultUrl = '/chargers';
          //   localStorage.setItem('defaultUrl', defaultUrl);
          // }
          if (permissionModules.includes('DEVICE')) {
            defaultUrl = '/v2/devices';
            localStorage.setItem('defaultUrl', defaultUrl);
          } else if (permissionModules.includes('REPORT')) {
            defaultUrl = '/reports/device/message-count';
            localStorage.setItem('defaultUrl', defaultUrl);
          } else if (permissionModules.includes('SCORE')) {
            defaultUrl = '/score';
            localStorage.setItem('defaultUrl', defaultUrl);
          } else if (permissionModules.includes('OTA') ||
            permissionModules.includes('OTA-PARTNER')) {
            defaultUrl = '/v2/ota';
            localStorage.setItem('defaultUrl', defaultUrl);
          } else if (permissionModules.includes('BENCH-TEST')) {
            defaultUrl = '/bench-test';
            localStorage.setItem('defaultUrl', defaultUrl);
          } else if (permissionModules.includes('CUSTOMER')) {
            defaultUrl = '/customer';
            localStorage.setItem('defaultUrl', defaultUrl);
          } else if (permissionModules.includes('CUSTOMER')) {
            defaultUrl = '/customers';
            localStorage.setItem('defaultUrl', defaultUrl);
          } else if (permissionModules.includes('API')) {
            defaultUrl = '/developer';
            localStorage.setItem('defaultUrl', defaultUrl);
          } else if (permissionModules.includes('SUPPORT')) {
            defaultUrl = '/support';
            localStorage.setItem('defaultUrl', defaultUrl);
          } else if (permissionModules.includes('ADMIN')) {
            if (permissionModules.includes('USER')) {
              defaultUrl = '/admin/users';
              localStorage.setItem('defaultUrl', defaultUrl);
            }
            // else if (permissionModules.includes('GROUP')) {
            //   defaultUrl = '/admin/groups';
            //   localStorage.setItem('defaultUrl', defaultUrl);
            // }
            else if (permissionModules.includes('ROLE')) {
              defaultUrl = '/admin/roles';
              localStorage.setItem('defaultUrl', defaultUrl);
            }
            // else if (permissionModules.includes('DEVICE')) {
            //   defaultUrl = '/admin/device';
            //   localStorage.setItem('defaultUrl', defaultUrl);
            // }
            else if (permissionModules.includes('ALERT')) {
              defaultUrl = '/admin/alerts';
              localStorage.setItem('defaultUrl', defaultUrl);
            } else if (permissionModules.includes('PLACE')) {
              defaultUrl = '/admin/place';
              localStorage.setItem('defaultUrl', defaultUrl);
            } else if (permissionModules.includes('SETTING')) {
              defaultUrl = '/admin/whitelabel';
              localStorage.setItem('defaultUrl', defaultUrl);
            } else if (permissionModules.includes('HEADER')) {
              defaultUrl = '/admin/headers';
              localStorage.setItem('defaultUrl', defaultUrl);
            } else if (permissionModules.includes('CACHE-ATTRIBUTES')) {
              defaultUrl = '/admin/cache-attributes';
              localStorage.setItem('defaultUrl', defaultUrl);
            } else if (permissionModules.includes('RULE')) {
              defaultUrl = '/admin/rules';
              localStorage.setItem('defaultUrl', defaultUrl);
            } else if (permissionModules.includes('AUDIT-TRIAL')) {
              defaultUrl = '/admin/audit-trial';
              localStorage.setItem('defaultUrl', defaultUrl);
            } else if (permissionModules.includes('DESTINATION')) {
              defaultUrl = '/admin/destination';
              localStorage.setItem('defaultUrl', defaultUrl);
            }
          } else {
            // let defaultUrl = '/';
            localStorage.setItem('defaultUrl', defaultUrl);
            this.logout();
          }
        }
      }
    }

    if (defaultUrl != undefined) {
      this.ngzone.run(() => {
        this.router.navigate([defaultUrl]);
      });
    }
  }

  /**
   * This will format the json input into reable format
   *
   * @param json : String
   * @returns
   */

  syntaxHighlight(jsonText: any) {
    let json = JSON.stringify(jsonText, undefined, 4);
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      let cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    });
  }

  logout() {
    let token = localStorage.getItem('token') || '';
    localStorage.clear();
    sessionStorage.clear();
    if (token) {
      this.authenticationService.logout(token).subscribe((res) => {
      });
    }
    this.ngzone.run(() => {
      this.router.navigate(['/login']);
    });
  }

  //to get lastlocation of the device using this appi 
  getVehicleDetail(deviceId: string): Observable<any> {
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    });
    return this.http.get(this.apiUrl + `messages/device/${deviceId}/snapped`, { headers }).pipe(
      catchError(this.handleError));
  }

  goToHistory(params: any, device?: any) {
    if (device) {
      localStorage.setItem('defaultselectvehicle', (device.length ? JSON.stringify(device[0]) : '{}'));
      // localStorage.setItem('defaultselectvehicle', JSON.stringify(value));
    }
    this.router.navigateByUrl('/*', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/trips'], params);
    });
  }

  public setdefaultselectvehicle(vehicleinfo: any) {
    // console.log("@@@@ set defaultselectvehicle",vehicleinfo);
    localStorage.setItem('defaultselectvehicle', JSON.stringify(vehicleinfo));
  }

  public getdefaultselectvehicle() {
    return JSON.parse(localStorage.getItem('defaultselectvehicle') || '{}');
  }

  // get title & subtitle
  getTitle() {
    const get = JSON.parse(localStorage.getItem('title') || '{}');
    return get;
  }

  setTitle(p1: string, p2: string) {
    localStorage.setItem('title', JSON.stringify({ title: p1, sub: p2 }));
  }

  public convertKPHtoMPH(value: any) {
    return Math.floor(value * 0.621371);
  }

  // To get the RecentdeviceData
  getRecentdeviceData(deviceId: string) {
    return this.http.get(this.apiUrl + 'trips/device/' + deviceId + '/recent').pipe(
      catchError(this.handleError));
  }
  getRecentdeviceDataAlternateAPI(deviceId: string) {
    return this.http.get(this.apiUrl + 'messages/device/' + deviceId + '/latest/occurrence').pipe(
      catchError(this.handleError));
  }
  dateToTimeAgo(p1: Date): string {
    const date = new Date(p1);
    const now = new Date(Date.now());
    const difftime = now.getTime() - date.getTime();
    const diffDate = new Date(difftime - 5.5 * 60 * 60 * 1000);
    const [sec, min, hr, day, month] = [
      diffDate.getSeconds(),
      diffDate.getMinutes(),
      diffDate.getHours(),
      diffDate.getDate() - 1,
      diffDate.getMonth(),
    ];
    const f = (property: number, end: string) => { return `${property} ${end}${property > 1 ? "s" : ""} ago`; };
    return month >= 1
      ? f(month, "month")
      : day >= 1
        ? f(day, "day")
        : hr >= 1
          ? f(hr, "hr")
          : min >= 1
            ? f(min, "min")
            : day >= 1
              ? f(sec, "sec")
              : "";
  }

  getSeekerData(deviceId: string, ts: number, te: number, offset: number): Observable<any> {
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    });
    return this.http.get(this.apiUrl + `messages/messagefilter/device/${deviceId}?startTime=${ts}&endTime=${te}&seeker=60&timeFormat=24&offsetInSeconds=${offset}`, { headers }).pipe(
      catchError(this.handleError));
  }

  checkSeeker(val: any) {
    if (this.activeSeeker.includes(val.ts)) {
      const index = this.activeSeeker.indexOf(val.ts);
      this.activeSeeker.splice(index, 1);
      return true; // return true in consideration that the seeker has been deselected
    } else if (this.activeSeeker.length < 1 || this.activeSeeker.length === 1) {
      this.activeSeeker = [];
      this.activeSeeker.push(val.ts);
      return false; // return false in consideration that the seeker has been selected
    }
  }

  checkSeekerActive(val: any) {
    if (this.activeSeeker.includes(val)) {
      return true;
    }
    return false;
  }
}
